<div class="scatter-graph">
  <div class="container">
    <div class="y-axis">
      <div class="visualization-name">MAP</div>
      <div class="map-selection">
        <app-button-group [items]="buttonItems" [value]="currentFeature()" [deselectable]="false" [vertical]="true"
                          (valueChange)="geoMapChanged($any($event))">
          <div *appButtonContent="let item" class="button">
            <mat-icon class="icon" inline [svgIcon]="item.icon">
            </mat-icon>
            <div class="label">{{item.label}}</div>
          </div>
        </app-button-group>
      </div>
    </div>
    <div class="visualization">
      <div class="visualization-area">
        <dvl-visualization [data]="data" #visualization></dvl-visualization>
      </div>
      <div class="x-axis-buttons">
      </div>
    </div>
    <div class="graphic-variables-selection">
      <div>
        <app-gv-button-group label="Color" icon="label:color" [variables]="variables" [type]="colorType"
                             [selected]="currentVariable('color')" [vertical]="true"
                             (variableChange)="variableChanged($event, 'color')">
        </app-gv-button-group>
      </div>
      <div>
        <app-gv-button-group label="Shape" icon="label:shape" [variables]="variables" [type]="shapeType"
                             [selected]="currentVariable('shape')" [vertical]="true"
                             (variableChange)="variableChanged($event, 'shape')">
        </app-gv-button-group>
      </div>
      <div>
        <app-gv-button-group label="Size" icon="label:size" [variables]="variables" [type]="sizeType"
                             [selected]="currentVariable('areaSize')" [vertical]="true"
                             (variableChange)="variableChanged($event, 'areaSize')">
        </app-gv-button-group>
      </div>
    </div>
  </div>
</div>
